module.exports = __webpack_public_path__ + "static/media/purple-s.5433c3f1.png";